export class ProjectsSerp {

    init() {
        this.setUnitsButtonLeftBehaviour();
        this.setUnitsButtonRightBehaviour()
    }

    private setUnitsButtonLeftBehaviour() {
        let unitsButtonLeftList = document.querySelectorAll(".units__button-left");
        unitsButtonLeftList.forEach(button => {
            button.addEventListener('click', function (event) {
                event.preventDefault()
                event.stopImmediatePropagation()
                let currentUnits = button.closest(".units-container")
                    ?.getElementsByClassName("units")
                    ?.item(0)
                if (currentUnits && "scrollLeft" in currentUnits) {
                    currentUnits.scrollBy({ left: -221, top: 0, behavior: 'smooth' })
                }
            })
        })
    }

    private setUnitsButtonRightBehaviour() {
        let unitsButtonRightList = document.querySelectorAll(".units__button-right");
        unitsButtonRightList.forEach(button => {
            button.addEventListener('click', function (event) {
                event.preventDefault()
                event.stopImmediatePropagation()
                let currentUnits = button.closest(".units-container")
                    ?.getElementsByClassName("units")
                    ?.item(0)
                if (currentUnits && "scrollLeft" in currentUnits) {
                    currentUnits.scrollBy({ left: 221, top: 0, behavior: 'smooth' })
                }
            })
        })
    }
}
